import { render, staticRenderFns } from "./ConfirmRedeemModal.vue?vue&type=template&id=8744f9f6&"
import script from "./ConfirmRedeemModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRedeemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports